import { Injectable } from '@angular/core';

import { AppConfig } from '../app.config';
import { throwError } from 'rxjs';
import { filter, map, catchError } from 'rxjs/operators';
import { HelpersService } from './helpers.service';

import { HttpClient } from '@angular/common/http';
import { ErrorHandlerService } from './errorhandler.service';// Add this for error feedback
 
@Injectable({
  providedIn: 'root',
})
export class InvoiceOptionsService {
  private env: any;

  constructor(
    private http: HttpClient,
    private appConfig: AppConfig,
    private helpersService: HelpersService, 
    private errorHandler: ErrorHandlerService,// Add this for error feedback
  ) {
    this.env = this.appConfig.getEnvironmentNew();
  }

  getInvoiceOptions(serviceID: string) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
          `/Bikeshop/QuoteOptions/${serviceID}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  getInvoiceOptionsMessagingStatus(partnerID: string) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
          `/Bikeshop/QuoteOptions/Template/Status/${partnerID}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  addInvoiceOption(data: any) {
    if (data.id || data.id === null) {
      delete data['id'];
    }
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url + `/Bikeshop/QuoteOption?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  updateInvoiceOption(data: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .put(
        this.env.url + `/Bikeshop/QuoteOption?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  deleteInvoiceOption(quoteOptionID: string) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .delete(
        this.env.url +
          `/Bikeshop/QuoteOption/${quoteOptionID}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  sentInvoiceOptionsToCustomer(serviceID: string) {
    const headers = this.helpersService.getNewApiHeaders();

    return this.http
      .post(
        this.env.url +
          `/Bikeshop/QuoteOption/Send/${serviceID}?code=${this.env.key}`,
        {},
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  sentInvoiceOptionsToCustomerV2(serviceID: string, sendToThirdPartyOnly) {
    const headers = this.helpersService.getNewApiHeaders();
    const data = {
      SendToThirdPartyOnly: sendToThirdPartyOnly
    };
    return this.http
      .post(
        this.env.url +
          `/Bikeshop/QuoteOption/Send/V2/${serviceID}?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  addInvoiceOptionLineItem(data: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url + `/Bikeshop/QuoteOption/LineItem?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  updateInvoiceOptionLineItem(data: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .put(
        this.env.url + `/Bikeshop/QuoteOption/LineItem?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  deleteInvoiceOptionLineItem(lineItemID: string) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .delete(
        this.env.url +
          `/Bikeshop/QuoteOption/LineItem/${lineItemID}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  getCustomerInvoiceOptions(serviceIdentifier: string) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url +
          `/Athlete/QuoteOptions/${serviceIdentifier}?code=${this.env.key}`,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  sentApprovalOptions(serviceIdentifier: string, data: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url +
          `/Athlete/QuoteOptions/Approval/${serviceIdentifier}?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }

  markApprovalOptionsSeen(serviceIdentifier: string, data: any) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url +
          `/Athlete/QuoteOptions/Seen/${serviceIdentifier}?code=${this.env.key}`,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res);
        }),
      );
  }
}
